export default "__VITE_ASSET__e901441c__"